import React, { useMemo } from 'react';
import Dropdown from '../../../../ui/Dropdown';
import useFilter from '../../useFilter';

const FilterDropdown = ({ type, className = '', disabled = false }) => {
  const { filters, handleFilterChange } = useFilter();

  const options = useMemo(() => {
    switch (type) {
      case 'productType':
        return [
          { value: '', label: 'All Products' },
          { value: 'physical', label: 'Physical' },
          { value: 'virtual', label: 'Virtual' }
        ];
      case 'transactionType':
        return [
          { value: '', label: 'All Transactions' },
          { value: 'forRent', label: 'For Rent' },
          { value: 'forSell', label: 'For Sale' }
        ];
      default:
        return [];
    }
  }, [type]);

  const handleChange = (value) => {
    if (disabled) return;

    if (type === 'transactionType') {
      if (value === '') {
        // Reset all transaction flags
        handleFilterChange({
          forRent: false,
          forSell: false
        });
      } else {
        // Set only the selected transaction flag
        handleFilterChange({
          forRent: value === 'forRent',
          forSell: value === 'forSell'
        });
      }
    } else if (type === 'productType') {
      // Map Physical/Virtual to isVirtual boolean filter
      if (value === 'virtual') {
        handleFilterChange({ isVirtual: true });
      } else if (value === 'physical') {
        handleFilterChange({ isVirtual: false });
      } else {
        // All Products - remove the filter
        handleFilterChange({ isVirtual: undefined });
      }
    }
  };

  const getValue = () => {
    // For transaction type, find which one is true
    if (type === 'transactionType') {
      return Object.keys(filters).find(key =>
        ['forRent', 'forSell'].includes(key) && filters[key]
      ) || '';
    }

    // For product type, map internal filter values to dropdown values
    if (type === 'productType') {
      if (filters.isVirtual === true) return 'virtual';
      if (filters.isVirtual === false) return 'physical';
      return '';
    }

    return filters[type] || '';
  };

  const getTitle = () => {
    switch (type) {
      case 'productType':
        return 'Product Type';
      case 'transactionType':
        return 'Transaction Type';
      default:
        return '';
    }
  };

  // Get the default option (the first one with empty value)
  const getDefaultOption = () => {
    return options.find(opt => opt.value === '') || { label: `All ${getTitle()}` };
  };

  return (
    <div className="flex flex-col gap-2 w-full">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-gray-700">{getTitle()}</span>
      </div>
      <Dropdown
        value={getValue()}
        onChange={handleChange}
        options={options}
        placeholder={getDefaultOption().label}
        maxWidth="none"
        className={className}
        disabled={disabled}
      />
    </div>
  );
};

export default FilterDropdown; 